import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { StepIndicatorModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { STEPINDICATORS } from 'config';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { HeaderService } from './../header/header.service';
@Component({
  selector: 'app-checkout',
  providers: [StepIndicatorService], // this service though part of StepIndicator component is provided from here to the component
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  steps: StepIndicatorModel[];
  displayFlag: boolean;
  stepSessionName: string;

  constructor(private stepindicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService, private headerService: HeaderService) {
    this.displayFlag = true;
    this.stepSessionName = 'checkout';
  }
  ngOnInit() {
    this.headerService.setCondensedFooterStatus(true);
    this.headerService.condensedHeader(this.stepSessionName);
    document.title = 'AT&T Business Console - Checkout - Terms and Conditions';
    this.breadCrumbService.setCurrentBreadCrumb(undefined);
    this.steps = STEPINDICATORS.stepobjArr.slice();
    if (this.stepindicatorService.getSteps(this.stepSessionName) === null) {
      this.stepindicatorService.setSteps(this.steps, this.stepSessionName);
    }
    this.steps = this.stepindicatorService.getSteps(this.stepSessionName);
    this.stepindicatorService.getVisibility().subscribe(
      (status: boolean) => {
        this.displayFlag = status;
      }
    );
  }
}
